import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/react"
import colors from "@constants/colors"
import Slider, { SliderProps } from "@material-ui/core/Slider"
import Tooltip from "./Tooltip"

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 58px;
  padding: 0 6px;

  .MuiSlider-rail {
    background-color: ${colors.midLight};
  }

  .MuiSlider-track,
  .MuiSlider-thumb {
    background-color: ${colors.midAccessible};
  }
`

const textStyles = css`
  position: absolute;
  font-family: Avenir;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: ${colors.midAccessible};
`

const Min = styled.div`
  ${textStyles}
  left: 0;
`

const Max = styled.div`
  ${textStyles}
  right: 0;
`

interface RangeSliderProps extends SliderProps {
  min: number
  max: number
  onChange?: any
  decimalPlaces?: number
  isCurrency?: boolean
}

const RangeSlider: React.FC<RangeSliderProps> = ({
  min,
  max,
  onChange,
  decimalPlaces,
  isCurrency,
  ...props
}) => {
  const [value, setValue] = React.useState<number[]>([0, 100])
  const range = max - min

  const handleChange = (event: any, newValue: number | number[]) => {
    setValue(newValue as number[])
  }

  const handleChangeCommited = (event: any, newValue: number | number[]) => {
    setValue(newValue as number[])

    if (onChange) {
      onChange(newValue)
    }
  }

  const getDisplayedValue = (value) => {
    let rangeAdjustedValue

    if (value === 0) {
      rangeAdjustedValue = min
    } else if (value === 100) {
      rangeAdjustedValue = max
    } else {
      rangeAdjustedValue = (value / 100) * range + min
    }

    const formattedValue = isCurrency
      ? rangeAdjustedValue.toFixed(2)
      : decimalPlaces
      ? rangeAdjustedValue.toFixed(decimalPlaces)
      : rangeAdjustedValue.toFixed(0)
    return `${isCurrency ? "$" : ""}${formattedValue}`
  }

  return (
    <Container>
      <Slider
        {...props}
        value={value}
        onChange={handleChange}
        onChangeCommitted={handleChangeCommited}
        valueLabelDisplay="auto"
        valueLabelFormat={getDisplayedValue}
        ValueLabelComponent={Tooltip}
        step={range < 1 ? 0.01 : 100 / range}
        // marks
      />
      <Min>{getDisplayedValue(value[0])}</Min>
      <Max>{getDisplayedValue(value[1])}</Max>
    </Container>
  )
}

export default RangeSlider
